<template>
  <div>
    <a-table
        :columns="columns"
        :data-source="dataSource"
        :pagination="ipagination"
        :loading="loading"
        rowKey="id"
        @change="handleTableChange">
      <template slot="state" slot-scope="text">
        <a-tag v-if="text===1" color="green"> 已支付 </a-tag>
        <a-tag v-else-if="text===0" color="red"> 未支付 </a-tag>
        <a-tag v-else-if="text===-1" color="blue"> 待支付 </a-tag>
      </template>
      <template slot="type" slot-scope="text">
        <a-tag v-if="text===1" color="cyan"> 微信 </a-tag>
        <a-tag v-else-if="text===0" color="purple"> 支付宝 </a-tag>
      </template>
    </a-table>
  </div>
</template>

<script>
import {getAction} from "@/api/manage";

export default {
  name: "PayLog",
  data(){
    return{
      dataSource: [],
      columns: [
        {
          title: '订单号',
          dataIndex: 'id',
          width: '35%',
        },
        {
          title: '支付方式',
          dataIndex: 'type',
          width: '15%',
          scopedSlots: {customRender: 'type'},
        },
        {
          title: '支付金额',
          dataIndex: 'amount',
          width: '15%',
        },
        {
          title: '支付状态',
          dataIndex: 'status',
          width: '15%',
          scopedSlots: {customRender: 'state'},
        },
        {
          title: '充值时间',
          dataIndex: 'createTime',
          width: '20%',
        },
      ],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '30', '50'],
        showTotal: (total, range) => {
          return "第" + range[0] + "至" + range[1] + "条,共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      loading: false,
      queryParam: {},
      isorter:{
        column: 'createTime',
        order: 'desc',
      },
      /* 筛选参数 */
      filters: {},
    }
  },
  created() {
    this.dataList()
  },
  methods:{
    handleTableChange(pagination, filters, sorter) {
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
      }
      this.ipagination = pagination;
      this.dataList();
    },
    dataList(arg) {
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      var param = {};
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      this.loading = true;
      getAction('/pay/logs', param).then(res => {
        if (res.success) {
          this.loading = false;
          this.dataSource = res.data.records;
          this.ipagination.total = res.data.total;
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
